import React from 'react';
import PropTypes from 'prop-types';
import { CirclePlus } from 'tabler-icons-react';
import AppStack from '../../common/AppStack';
import AppFlexbox from '../../common/AppFlexbox';
import AppText from '../../common/AppText';
import * as classes from '../../../styles/nestedStyles.module.css';
import AppCard from '../../common/AppCard';
import AppImage from '../../common/AppImage';

const PrintDesignEditorTemplateSelector = ({
  ecomExternalProducts,
  formState,
  setFormState
}) => {
  const productPrintTemplates =
    formState.productDesigns?.filter(
      (t) => t.productId === formState.selectedProductId
    ) || [];

  return (
    <AppFlexbox style={{ gap: 16 }}>
      {productPrintTemplates
        .sort((a, b) => a.sort - b.sort)
        .map((p) => (
          <AppCard
            key={p.id}
            className={classes['hover-action-card']}
            onClick={() =>
              setFormState({ ...formState, selectedProductDesignId: p.id })
            }
            radius={8}
            shadow="xl"
            style={{
              padding: 0,
              height: '100%',
              maxWidth: 60,
              minWidth: 60,
              border:
                formState.selectedProductDesignId === p.id
                  ? 'solid 1px dodgerblue'
                  : 'solid 1px lightgrey'
            }}
            withBorder
          >
            <AppStack
              style={{
                gap: 8,
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100%'
              }}
            >
              {p.previewImage ? (
                <AppImage fit="contain" src={p.previewImage} />
              ) : null}
            </AppStack>
          </AppCard>
        ))}

      <AppCard
        className={classes['hover-action-card']}
        onClick={() =>
          setFormState({ ...formState, showTemplateCreateModal: true })
        }
        radius={8}
        style={{
          gap: 8,
          height: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 16,
          borderColor: 'dodgerblue'
        }}
        withBorder
      >
        <AppFlexbox
          style={{ gap: 5, justifyContent: 'center', alignItems: 'center' }}
        >
          <CirclePlus size={24} style={{ color: 'dodgerblue' }} />
          <AppText
            style={{
              color: 'dodgerblue',
              fontSize: 14,
              textAlign: 'center',
              fontWeight: 500
            }}
          >
            New design
          </AppText>
        </AppFlexbox>
      </AppCard>
    </AppFlexbox>
  );
};

PrintDesignEditorTemplateSelector.propTypes = {
  ecomExternalProducts: PropTypes.array.isRequired,
  formState: PropTypes.object.isRequired,
  setFormState: PropTypes.func.isRequired
};

export default PrintDesignEditorTemplateSelector;
